import ContactsVueInstance from '@arexo/contacts-module';
import OffersVueInstance from '@arexo/offers-module';
import DeliveriesVueInstance from '@arexo/planning-module';
import TreatmentsVueInstance from '@arexo/revatech-treatments-module';
import ExitProcessVueInstance from '@arexo/revatech-module-exit';
import { createAppVue } from '@arexo/invoices-module';
import Configuration from './model/Configuration';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueI18n from 'vue-i18n';
import BootstrapVue from 'bootstrap-vue';
import { store } from './store/store';
import messages from './translation/message';
import dateTimeFormats from './translation/dateTimeFormats';
import numberFormats from './translation/numberFormats';
import FlagIcon from 'vue-flag-icon-2';
import Icon from 'vue-awesome/components/Icon';

import './assets/css/custom.scss';
import 'vue-awesome/icons';

Vue.config.productionTip = false;

Vue.component('v-icon', Icon);

Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(FlagIcon);

const i18n = new VueI18n({
  fallbackLocale: 'en-GB',
  locale: 'en-GB',
  messages,
  dateTimeFormats,
  numberFormats
});

Vue.filter('capitalize', function (value) {
  return value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : value;
});

const invoicesVueInstance = createAppVue('/invoices');
invoicesVueInstance.$store.dispatch('configuration/loadConfiguration', Configuration.invoiceConfig);

const preInvoicesVueInstance = createAppVue('/pre-invoices');
preInvoicesVueInstance.$store.dispatch('configuration/loadConfiguration', Configuration.preInvoiceConfig);

Vue.mixin({
  data() {
    return {
      get contactsVueInstance() {
        return ContactsVueInstance;
      },
      get offersVueInstance() {
        return OffersVueInstance;
      },
      get deliveriesVueInstance() {
        return DeliveriesVueInstance;
      },
      get treatmentsVueInstance() {
        return TreatmentsVueInstance;
      },
      get preInvoicesVueInstance() {
        return preInvoicesVueInstance;
      },
      get invoicesVueInstance() {
        return invoicesVueInstance;
      },
      get exitProcessVueInstance() {
        return ExitProcessVueInstance;
      }

    };
  }
});
export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
});
